import { HStack } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';

import { Participant } from 'features/participants/config/types';
import { useParticipantsQuery } from 'features/participants/hooks';

import ButtonLink from 'shared/components/Button/ButtonLink';

import { HeaderTabsParticipantsMenu } from './ParticipantsMenu';

const PARTICIPANTS = {
  subRoute: '/hde/participants',
  label: 'Participants',
};
const CONTROL_CENTER = {
  subRoute: '/hde/task-manager',
  label: 'Control Center',
};

const participantMapper = ({
  userName,
  userId,
  userEmail,
  userPicture,
}: Participant) => {
  return {
    userName,
    userId,
    userEmail,
    pictureUrl: userPicture.url,
  };
};

export const MainHeaderTabs = () => {
  const location = useLocation();

  // @ts-ignore
  const { participants } = useParticipantsQuery(participantMapper);

  const [, first, second] = location.pathname.split('/');
  const subRoute = `/${first}/${second}`;

  const isParticipantsActive = subRoute === PARTICIPANTS.subRoute;
  const isControlCenterActive = subRoute === CONTROL_CENTER.subRoute;

  return (
    <HStack>
      <HeaderTabsParticipantsMenu
        participants={participants}
        isActive={isParticipantsActive}
      />
      <ButtonLink
        size="xs"
        to={CONTROL_CENTER.subRoute}
        color={isControlCenterActive ? 'primary' : 'gray'}
        variant={isControlCenterActive ? 'solid' : 'outline'}
      >
        {CONTROL_CENTER.label}
      </ButtonLink>
    </HStack>
  );
};
